import { useMemo } from "react";

import { useShallow } from "zustand/react/shallow";

import {
  selectCurrentItem,
  selectItemsSortedByShelf,
  selectOrderDetailsFromContext,
} from "../stores/pickingSelectors";
import { usePickingStore } from "../stores/usePickingStore";

export function useSelectItemsSortedByShelf() {
  const context = usePickingStore((state) => state);
  return useMemo(() => selectItemsSortedByShelf(context), [context]);
}

export function useSelectCurrentItem() {
  const context = usePickingStore((state) => state);
  return useMemo(() => selectCurrentItem(context), [context]);
}

export function useGiftQuantites() {
  return usePickingStore(
    useShallow((state) => ({
      picked: state.pickedGiftsQuantity,
      total: state.totalGiftsQuantity,
    })),
  );
}

export function useCampaignQuantites() {
  return usePickingStore(
    useShallow((state) => ({
      picked: state.pickedCampaignsQuantity,
      total: state.totalCampaignsQuantity,
    })),
  );
}

export function useRemoveFlyersQuantites() {
  return usePickingStore(
    useShallow((state) => ({
      picked: state.pickedRemoveFlyersQuantity,
      total: state.totalRemoveFlyersQuantity,
    })),
  );
}

export function useSelectOrderDetails() {
  return usePickingStore(useShallow(selectOrderDetailsFromContext));
}
